import React from "react";

const TableLoadingSkeleton = ({
    mode = "table",
    columnLabels = [],
    columnTypes = [],
    columnTemplate = "56px 1.6fr 1.2fr 0.9fr 0.9fr 1.2fr 1.2fr 1fr",
    rowCount = 4,
    gridCount = 8,
    containerClassName = "",
    headerClassName = "",
    headerTextClassName = "text-white",
    headerCellClassName = "text-center",
    actionsCount = 2,
}) => {
    const resolvedColumnTypes = columnTypes.length
        ? columnTypes
        : columnLabels.map((_, idx) => {
            if (idx === 0) return "image";
            if (idx === columnLabels.length - 1) return "actions";
            return "text";
        });

    if (mode === "grid") {
        return (
            <div className={`grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 p-4 ${containerClassName}`}>
                {[...Array(gridCount)].map((_, idx) => (
                    <div key={idx} className="rounded-lg border border-gray-200 p-3">
                        <div className="h-28 rounded bg-gray-100 animate-pulse" />
                        <div className="mt-3 h-3 bg-gray-100 rounded animate-pulse" />
                        <div className="mt-2 h-3 w-2/3 bg-gray-100 rounded animate-pulse" />
                        <div className="mt-3 h-6 w-16 bg-gray-100 rounded animate-pulse" />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={`w-full ${containerClassName}`}>
            <div
                className={`grid gap-2 text-sm font-medium ${headerClassName}`}
                style={{ background: "var(--color-primary)", gridTemplateColumns: columnTemplate }}
            >
                {columnLabels.map((label, idx) => (
                    <div
                        key={`${label}-${idx}`}
                        className={`${headerCellClassName} px-4 py-3 whitespace-nowrap ${headerTextClassName}`}
                    >
                        {label}
                    </div>
                ))}
            </div>
            <div className="divide-y">
                {[...Array(rowCount)].map((_, idx) => (
                    <div
                        key={idx}
                        className="grid gap-2 px-4 py-4 items-center"
                        style={{ gridTemplateColumns: columnTemplate }}
                    >
                        {resolvedColumnTypes.map((type, cellIdx) => {
                            if (type === "image") {
                                return (
                                    <div key={cellIdx} className="flex justify-center">
                                        <div className="h-10 w-10 rounded border bg-gray-100 animate-pulse" />
                                    </div>
                                );
                            }
                            if (type === "actions") {
                                return (
                                    <div key={cellIdx} className="flex justify-center gap-2">
                                        {[...Array(actionsCount)].map((__, actionIdx) => (
                                            <div key={actionIdx} className="h-7 w-16 rounded bg-gray-100 animate-pulse" />
                                        ))}
                                    </div>
                                );
                            }
                            if (type === "badge") {
                                return (
                                    <div key={cellIdx} className="flex justify-center">
                                        <div className="h-5 w-20 rounded-full bg-gray-100 animate-pulse" />
                                    </div>
                                );
                            }
                            return (
                                <div key={cellIdx} className="h-3 bg-gray-100 rounded animate-pulse" />
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TableLoadingSkeleton;
